/**
 * Enum for registration step statuses.
 * @readonly
 * @enum {string}
 */
export default Object.freeze({
  Complete: 'Complete',
  Pending: 'Pending',
  Skipped: 'Skipped',
})
